import React from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch, useSelector } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import EndSubscription from "../../assets/images/Subscription/EndSubscription.webp";
import PreviousBills from "../../assets/images/Subscription/PreviousBills.webp";
import UpgradeSubscription from "../../assets/images/Subscription/UpgradeSubscription.webp";
import Benifit1 from "../../assets/images/Subscription/benifit1.webp";
import Benifit2 from "../../assets/images/Subscription/benifit2.webp";
import Benifit3 from "../../assets/images/Subscription/benifit3.webp";

// get base_url
const { protocol, hostname, port } = window.location;
const portPart = port ? `:${port}` : ""; // Include port if it exists
const fullURL = `${protocol}//${hostname}${portPart}`;

const menuOption = [
  {
    name: "Previous bills",
    key: 321,
    subtitle: "View historic transactions",
    src: PreviousBills,
  },
  {
    name: "Upgrade subscription",
    key: 322,
    subtitle: "View all plans",
    src: UpgradeSubscription,
  },
  {
    name: "End subscription",
    key: 323,
    subtitle: "Discontinue your plan",
    src: EndSubscription,
  },
];

const benifitsOption = [
  {
    name: "Customised workouts",
    key: 3223,
    src: Benifit1,
  },
  {
    name: "Customised meals",
    key: 3222,
    src: Benifit2,
  },
  {
    name: "Exclusive articles",
    key: 3221,
    src: Benifit3,
  },
];

export default function Menu() {
  const { profileDetails } = useSelector((state) => state.webUtilities);

  const dispatch = useDispatch();
  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
  };

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(3));
  };

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
      </div>
      <div className="flex flex-col gap-2 mt-2 w-11/12 mx-auto pb-14">
        <p className="text-2xl font-semibold mb-2 text-center">Subscription</p>
        <div className="mt-3">
          {profileDetails &&
            profileDetails.subscription &&
            profileDetails.subscription.map((item, index) => (
              <div
                key={index}
                className="border border-[#23B3F1] px-2 py-2 bg-[#E2F6FF] rounded-2xl"
              >
                <div className="flex w-full justify-between">
                  <div className="flex gap-2">
                    <div
                      className="w-14 h-14 rounded-full flex justify-center items-center"
                      style={{
                        backgroundImage:
                          "linear-gradient(134deg, rgba(255, 255, 255, 0.94) 0%, #088BF5 100%)",
                      }}
                    >
                      <img
                        src={fullURL + "/images/fire.webp"}
                        className="w-7"
                        alt="nwon"
                      />
                    </div>
                    <div className="mt-2">
                      <p className="text-sm font-bold">{item?.name}</p>
                      <p className="text-xs">{item?.sku}</p>
                    </div>
                  </div>
                  <div className="flex justify-center items-center">
                    {item.isActive && (
                      <button className="text-white rounded-xl bg-[#088BF5] px-3 py-1">
                        Active
                      </button>
                    )}
                  </div>
                </div>
                <div className="flex justify-between mt-3 bg-[white] w-11/12 mx-auto px-2 py-3 rounded-lg">
                  <p className="text-[#DADADA]">$ {item?.price}</p>
                  <p className="text-black font-semibold">$ {item?.credits}</p>
                </div>
                <p className="text-black text-sm text-center mt-2 font-normal">
                  only $ {item?.pricePerWeek} per week
                </p>
              </div>
            ))}
        </div>
        <p className="text-black text-sm text-center mt-5 font-medium">
          Your subscription includes{" "}
          <span className="text-[#FE7701]"> unlimited access</span> to
        </p>
        <div className="mt-3 flex justify-between ">
          {benifitsOption.map((item) => (
            <div
              key={item.key}
              className={`w-3/12 flex flex-col justify-center text-center items-center`}
            >
              <div className="w-8 h-8 flex justify-center items-center">
                <img src={item?.src} className="w-8" alt="nwon" />
              </div>
              <p className="text-xs mt-2 font-medium">{item?.name}</p>
            </div>
          ))}
        </div>
        {/* <div className="mt-5">
          {menuOption.map((item) => (
            <div key={item.key} className={`fasweekdes sidemenubox`}>
              <div className="mode1">
                <div>
                  <img loading="lazy" src={item.src} alt={item.name} />
                </div>
                <div className="tabroe">
                  <div className="sidetest text-base leading-snug">
                    {item.name}
                  </div>
                  <div className="modesutittex text-gray-500 text-[11px]">
                    {item.subtitle}
                  </div>
                </div>
              </div>
              <div
                className="cursor-pointer"
                onClick={() => handleChangeSidebar(item.key)}
              >
                <div className="sidearro">
                  <img
                    loading="lazy"
                    src={fullURL + "/images/deshboard/chevron.webp"}
                    alt="chevron"
                  />
                </div>
              </div>
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
}
